import axios from 'axios'

export default axios.create({
  baseURL: `${process.env.VUE_APP_STREAMING_API_URL}/`,
  headers: {
    'Content-type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})
